import { TReduxActions } from '../../../../shared/types/redux';

export const DOMAIN_UPDATE = 'domain/SET_DOMAIN';

export interface IDomain {
  domain: string;
}

export interface IDomainAction {
  type: 'domain/SET_DOMAIN';
  payload: {
    domain: string;
  };
}

const initialState: IDomain = {
  domain: 'www',
};

export const setDomain = (domain: string): IDomainAction => {
  return {
    type: DOMAIN_UPDATE,
    payload: {
      domain,
    },
  };
};

export const domainReducer = (state = initialState, action: TReduxActions) => {
  switch (action.type) {
    case DOMAIN_UPDATE:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
};
